import { useState } from 'react';
import { Check, Copy } from 'lucide-react';
import { getProspectPortalLoginUrl } from '../../config/api';

async function copyToClipboard(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    const input = document.createElement('textarea');
    input.value = value;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    const copied = document.execCommand('copy');
    input.remove();
    return copied;
  }
}

/** Phone-only reminder with a one-tap copy of the prospect login link. */
export default function ProspectDesktopLinkCard() {
  const loginUrl = getProspectPortalLoginUrl();
  const [copied, setCopied] = useState(false);
  const [copyFailed, setCopyFailed] = useState(false);

  const copyLink = async () => {
    const ok = await copyToClipboard(loginUrl);
    if (!ok) {
      setCopied(false);
      setCopyFailed(true);
      return;
    }
    setCopyFailed(false);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="mb-4 rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-gray-800 px-4 py-4 shadow-bento md:hidden">
      <p className="text-sm font-semibold text-gray-900 dark:text-white">
        <span aria-hidden="true">⚠️ </span>
        We think this is a big screen job.
      </p>
      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
        Although it&apos;s possible to do on a phone, your experience will be a lot easier if you do this on a
        computer. Copy the login link and text, or email it to yourself. Then open it on your computer and
        sign in.
      </p>
      <button
        type="button"
        onClick={() => {
          void copyLink();
        }}
        className="mt-3 inline-flex min-h-11 items-center gap-2 rounded-lg bg-gray-900 px-3 py-2 text-sm font-semibold text-white dark:bg-white dark:text-gray-900"
        data-login-url={loginUrl}
      >
        {copied ? <Check size={16} aria-hidden="true" /> : <Copy size={16} aria-hidden="true" />}
        {copied ? 'Copied' : copyFailed ? "Couldn't copy" : 'Copy link'}
      </button>
    </div>
  );
}
